module.exports = __webpack_public_path__ + "media/images/icons/ic-favorites-a07c63b4a96693b5043c5057b24482cb.svg";